import React from "react";
import { Helmet } from "react-helmet-async";

const SITE = "https://www.indravax.com";
const LOGO = "https://customer-assets.emergentagent.com/job_execution-hub-52/artifacts/f0e2q5kr_40434786-BC05-497A-BBE0-931848E37F84-removebg-preview.png";

const SEO = ({ title, description, path = "/", image = LOGO, type = "website", keywords }) => {
    const fullTitle = title
        ? `${title} | Indravax Strategic Advisory LLP`
        : "Indravax Strategic Advisory LLP | Global Strategic Advisory & Transactions";
    const url = `${SITE}${path}`;
    return (
        <Helmet>
            <title>{fullTitle}</title>
            <meta name="description" content={description} />
            {keywords && <meta name="keywords" content={keywords} />}
            <link rel="canonical" href={url} />

            {/* Open Graph */}
            <meta property="og:type" content={type} />
            <meta property="og:title" content={fullTitle} />
            <meta property="og:description" content={description} />
            <meta property="og:url" content={url} />
            <meta property="og:image" content={image} />
            <meta property="og:site_name" content="Indravax Strategic Advisory LLP" />

            {/* Twitter */}
            <meta name="twitter:card" content="summary_large_image" />
            <meta name="twitter:title" content={fullTitle} />
            <meta name="twitter:description" content={description} />
            <meta name="twitter:image" content={image} />
        </Helmet>
    );
};

export default SEO;
